import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getStade,
    getMetaux,
    getTypeProduit,
    getStatut,
    getOfEnCours,
    getOfLivre,
    getOfLivreExtensia,
    getOfFromId,
    setOfToEdit,
    getListeOf,
    getTypeCommande,
    getTypeCom,
    getAnalyseMargeTotaux,
    getAnalyseMargeClasses,
    getAnalyseMargeDetails,
    getAnalyseMargeEfficacite,
    getAnalyseMargeTotauxLivres,
    getAnalyseMargeClassesLivres,
    getAnalyseMargeDetailsLivres,
    getAnalyseMargeEfficaciteLivres
} from '../actions';
import FilterSelect from '../components/filterSelect';
import FilterInput from '../components/filterInput';
import TreeClient from '../components/treeClient';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Card,
    CardContent,
    Typography,
    Grid,
    Paper
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import { imagesRepo, localization } from '../config';
import MaterialTable, { MTableToolbar } from 'material-table';
import { Autocomplete } from '@material-ui/lab';
import TracerOf from './tracerOf';
import { addDayToToday, euroFormat, exportCsv } from '../helpers/functions';
import OfEditComponent from '../components/of/OfEditComponent';
import Image from 'react-bootstrap/Image';
import { Doughnut, Bar } from 'react-chartjs-2';
import 'chart.js';

class FilterTester extends Component {
    constructor (props) {
        super(props);
        const currentYear = new Date().getFullYear();

        this.dataDevis = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'DEVIS' }, { id: 0, description: 'NORMAL' }];
        this.dataImperatif = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'IMPERATIF' }, { id: 0, description: 'NORMAL' }];
        this.dataTypeCommande = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'TOURNEE' }, { id: 0, description: 'NORMAL' }];
        this.dataFacon = [{ id: 2, description: 'TOUT' }, { id: 1, description: 'A FACON' }, { id: 0, description: 'NORMAL' }];
        this.dataResa = [{ id: 2, description: 'NON RESERVE' }, { id: 1, description: 'RESERVATION' }, { id: 0, description: 'TOUT' }];
        this.sortedColumn = null;
        this.orderDirection = null;
        this.state = {
            filterOpen: false,
            ofToTrace: '',
            stade: '',
            metal: '',
            type: '',
            statut: '',
            ref: '',
            of: '',
            facture: '',
            client: '',
            ref_clt: '',
            tournee: null,
            debut: `${currentYear}-01-01`,
            fin: addDayToToday(30),
            open: false,
            devis: null,
            facon: null,
            openEditOf: false,
            imperatif: null,
            totalheure: 0,
            totalCA: 0,
            poidsTotal: 0,
            dataClone: [],
            dataLivreClone: [],
            nbARticlesLivre: 0,
            totalCALivre: 0,
            poidsTotalLivre: 0,
            prixRevientLivre: 0,
            dataLivreCloneExtensia: [],
            totalCALivreExtensia: 0,
            typecommande: null,
            typeResa: null,
            commission: null,
            selectedEnCours: '',
            selectedLivre: '',
            selectedLivreExtensia: '',
            openAnalyseMarges: false,
            analyseMargesData: {
                totaux: null,
                classes: [],
                details: [],
                efficacite: []
            },
            openAnalyseMargesLivres: false,
            analyseMargesLivresData: {
                totaux: null,
                classes: [],
                details: [],
                efficacite: []
            },
            imageZoomOpen: false,
            zoomImageSrc: '',
            zoomImageTitle: ''
        };

    }

    componentDidMount() {
        const { getStade, getMetaux, getTypeProduit, getStatut, getListeOf, getTypeCommande, getTypeCom } = this.props;
        getTypeCom();
        getStade();
        getMetaux();
        getTypeProduit();
        getStatut();
        getListeOf();
        getTypeCommande();
    }

    getFilter = () => ({
        stade: this.state.stade,
        metal: this.state.metal,
        type: this.state.type,
        statut: this.state.statut,
        ref: this.state.ref,
        of: this.state.of,
        facture: this.state.facture,
        client: this.state.client,
        ref_clt: this.state.ref_clt,
        tournee: this.state.tournee ? this.state.tournee.id : 2,
        debut: this.state.debut,
        fin: this.state.fin,
        devis: this.state.devis ? this.state.devis.id : 2,
        facon: this.state.facon ? this.state.facon.id : 2,
        imperatif: this.state.imperatif ? this.state.imperatif.id : 2,
        type_commande: this.state.typecommande ? this.state.typecommande : 0,
        type_resa: this.state.typeResa ? this.state.typeResa.id : 0,
        commission: this.state.commission ? this.state.commission.id_typ_com : 0,
    });

    onChange = (data, labelState) => {
        const label = labelState.toLowerCase()
        this.setState({ [label]: data })  //, () => this.refreshLists()
    }
    handleChangeClient = (data) => {
        this.setState({ client: data })  //, () => this.refreshLists()
    }

    refreshLists = () => {
        const { getOfEnCours, getOfLivre, getOfLivreExtensia } = this.props;
        getOfEnCours(this.getFilter()).then(() => this.listeEnCours());
        getOfLivre(this.getFilter()).then(() => this.listeLivre());
        getOfLivreExtensia(this.getFilter()).then(() => this.listeLivreExtensia());
    };

    printList = (dataClone) => {
        console.log(dataClone);

        const ofsString = dataClone.map(item => item.num_sachet).join(',');
        const url = `https://www.extensia-france.com/printers/commandePrinter.php?ofs=${ofsString}&sort=${this.sortedColumn}&order=${this.orderDirection}`;
        window.open(url, '_blank');
    };

    isMobile = () => isWidthDown('sm', this.props.width);

    columnsEnCours = () => {
        const mobile = this.isMobile();
        return [
            { align: 'center', title: 'Image', export: false, field: 'image', hidden: mobile, render: rowData => this.renderZoomableImage(rowData) },
            { align: 'left', title: 'Type', field: 'type_produit', hidden: true },
            { align: 'left', title: 'OF', field: 'num_sachet', type: 'numeric' },
            { align: 'left', title: 'Date Créa', field: 'date_crea', hidden: mobile },
            { align: 'left', title: 'Client', field: 'bijouterie' },
            { align: 'left', title: 'Stade', field: 'lestade', hidden: mobile },
            { align: 'left', title: 'Ref Clt', field: 'ref_clt' },
            { align: 'left', title: 'Métal', field: 'lemetal' },
            { align: 'left', title: 'Doigt', field: 'dim', type: 'numeric', hidden: mobile },
            { align: 'left', title: 'Référence', field: 'ref_cv' },
            { align: 'left', title: 'Désignation', field: 'ref' },
            { align: 'left', title: 'Notes', field: 'Notes', hidden: mobile },
            { align: 'left', title: 'Date Livraison', field: 'date_livr', hidden: mobile },
            { align: 'left', title: 'Prix HT', field: 'prix_fact', type: 'numeric', hidden: mobile },
            { align: 'left', title: 'Statut', field: 'lestatut' },
        ]
    }
    listeEnCours = () => {
        const { listeOfEnCours } = this.props;
        let totalCA = 0, poidsTotal = 0;
        listeOfEnCours.forEach(r => {
            totalCA += parseFloat(r.prix_fact);
            poidsTotal += parseFloat(r.poids);
        });
        const dataClone = [...listeOfEnCours];
        this.setState({ dataClone, totalCA, poidsTotal });
    };

    listeLivre = () => {
        const { listeOfLivre } = this.props;
        let totalCALivre = 0, poidsTotalLivre = 0, prixRevientLivre = 0;
        listeOfLivre.forEach(r => {
            totalCALivre += parseFloat(r.totht);
            poidsTotalLivre += parseFloat(r.poids_u);
            prixRevientLivre += parseFloat(r.prix_r);
        });
        const dataLivreClone = [...listeOfLivre];
        this.setState({ dataLivreClone, totalCALivre, poidsTotalLivre, prixRevientLivre });
    };

    listeLivreExtensia = () => {
        const { listeOfLivreExtensia } = this.props;
        let totalCALivreExtensia = 0;
        listeOfLivreExtensia.forEach(r => {
            totalCALivreExtensia += parseFloat(r.totht);
        });
        const dataLivreCloneExtensia = [...listeOfLivreExtensia];
        this.setState({ dataLivreCloneExtensia, totalCALivreExtensia });
    };

    tracerOf = (of) => {
        this.setState({ open: true, ofToTrace: of });
    };

    editerOf = (of) => {
        const { listeOfs, setOfToEdit } = this.props;
        const data = listeOfs.find(f => f.num_sachet === of);
        setOfToEdit(data);
        this.setState({ openEditOf: true });
    };

    openImageZoom = (image, title = '') => {
        if (!image) return;

        this.setState({
            imageZoomOpen: true,
            zoomImageSrc: `${imagesRepo}${image}`,
            zoomImageTitle: title || 'Aperçu image'
        });
    };

    closeImageZoom = () => {
        this.setState({
            imageZoomOpen: false,
            zoomImageSrc: '',
            zoomImageTitle: ''
        });
    };

    renderZoomableImage = (rowData) => {
        if (!rowData?.image) return null;

        const title = rowData.ref_cv || rowData.ref || rowData.designation || `OF ${rowData.num_sachet}`;

        return (
            <div
                style={{ display: 'inline-flex', cursor: 'zoom-in' }}
                onClick={(event) => {
                    event.stopPropagation();
                    this.openImageZoom(rowData.image, title);
                }}
                title="Cliquer pour agrandir"
            >
                <Image
                    key={rowData.num_sachet}
                    src={`${imagesRepo}thumbs.php?src=${rowData.image}&size=120`}
                    style={{ width: 100, height: 100, objectFit: 'cover' }}
                    rounded
                />
            </div>
        );
    };

    ouvrirAnalyseMarges = async () => {
        this.setState({ openAnalyseMarges: true });

        // Charger les données d'analyse avec les filtres actuels
        const filtres = this.getFilter();
        const { getAnalyseMargeTotaux, getAnalyseMargeClasses, getAnalyseMargeDetails, getAnalyseMargeEfficacite } = this.props;

        try {
            const totauxResult = await getAnalyseMargeTotaux(filtres);
            const classesResult = await getAnalyseMargeClasses(filtres);
            const detailsResult = await getAnalyseMargeDetails(filtres);
            const efficaciteResult = await getAnalyseMargeEfficacite(filtres);

            this.setState({
                analyseMargesData: {
                    totaux: totauxResult,
                    classes: classesResult,
                    details: detailsResult,
                    efficacite: efficaciteResult
                }
            });
        } catch (error) {
            console.error('Erreur lors du chargement des données d\'analyse:', error);
        }
    };

    ouvrirAnalyseMargesLivres = async () => {
        this.setState({ openAnalyseMargesLivres: true });

        // Charger les données d'analyse livrés avec les filtres actuels
        const filtres = this.getFilter();
        const { getAnalyseMargeTotauxLivres, getAnalyseMargeClassesLivres, getAnalyseMargeDetailsLivres, getAnalyseMargeEfficaciteLivres } = this.props;

        try {
            const totauxResult = await getAnalyseMargeTotauxLivres(filtres);
            const classesResult = await getAnalyseMargeClassesLivres(filtres);
            const detailsResult = await getAnalyseMargeDetailsLivres(filtres);
            const efficaciteResult = await getAnalyseMargeEfficaciteLivres(filtres);

            this.setState({
                analyseMargesLivresData: {
                    totaux: totauxResult,
                    classes: classesResult,
                    details: detailsResult,
                    efficacite: efficaciteResult
                }
            });
        } catch (error) {
            console.error('Erreur lors du chargement des données d\'analyse livrés:', error);
        }
    };

    createLabelEnCours = () => {
        const { listeOfEnCours } = this.props;
        const label = "OFS EN COURS";
        const mobile = this.isMobile();
        if (listeOfEnCours.length > 0) {
            return (
                <div style={{ width: '100%', display: 'flex', flexDirection: mobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: mobile ? 'flex-start' : 'center', gap: mobile ? 6 : 0 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: mobile ? '4px' : '10px', flex: 1, fontSize: mobile ? '0.8em' : 'inherit' }}>
                        <span style={{ fontSize: '1.2em', color: '#115293' }}>{listeOfEnCours.length}</span> EN COURS : <span style={{ fontSize: '1.2em', color: '#115293' }}>{euroFormat(this.state.totalCA)}</span>
                        {!mobile && <><span>-</span><span>Poids <span style={{ fontSize: '1.2em', color: '#115293' }}>{this.state.poidsTotal.toFixed(2)}</span> Gr</span></>}
                    </div>
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                        {(() => {
                            const user = JSON.parse(localStorage.getItem('user'))?.[0];
                            return user?.role === 1 && (
                                <Button
                                    variant="contained"
                                    size={mobile ? 'small' : 'medium'}
                                    style={{
                                        background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
                                        color: 'white',
                                        boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
                                    }}
                                    onClick={this.ouvrirAnalyseMarges}
                                >
                                    {mobile ? 'Marges' : 'Analyse Marges'}
                                </Button>
                            );
                        })()}
                        <Button variant="contained" color="primary" size={mobile ? 'small' : 'medium'} onClick={() => this.printList(this.state.dataClone)}>
                            Imprimer
                        </Button>
                    </div>
                </div>
            );
        } else {
            return <div>{label}</div>;
        }
    };

    createLabelLivre = () => {
        const { listeOfLivre } = this.props;
        const labelLivre = "OFS LIVRES";
        const mobile = this.isMobile();
        if (listeOfLivre.length > 0) {
            return (
                <div style={{ width: '100%', display: 'flex', flexDirection: mobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: mobile ? 'flex-start' : 'center', gap: mobile ? 6 : 0 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: mobile ? '4px' : '10px', flex: 1, fontSize: mobile ? '0.8em' : 'inherit' }}>
                        <span style={{ fontSize: '1.2em', color: '#115293' }}>{listeOfLivre.length}</span> LIVRÉS : <span style={{ fontSize: '1.2em', color: '#115293' }}>{euroFormat(this.state.totalCALivre)}</span>
                        {!mobile && <><span>-</span><span>Poids <span style={{ fontSize: '1.2em', color: '#115293' }}>{this.state.poidsTotalLivre.toFixed(2)}</span> Gr</span>
                        <span>-</span><span>Revient <span style={{ fontSize: '1.2em', color: '#115293' }}>{euroFormat(this.state.prixRevientLivre)}</span></span></>}
                    </div>
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                        {(() => {
                            const user = JSON.parse(localStorage.getItem('user'))?.[0];
                            return user?.role === 1 && (
                                <Button
                                    variant="contained"
                                    size={mobile ? 'small' : 'medium'}
                                    style={{
                                        background: 'linear-gradient(45deg, #28a745 30%, #20c997 90%)',
                                        color: 'white',
                                        boxShadow: '0 3px 5px 2px rgba(40, 167, 69, .3)',
                                    }}
                                    onClick={this.ouvrirAnalyseMargesLivres}
                                >
                                    {mobile ? 'Marges' : 'Analyse Marges Livrés'}
                                </Button>
                            );
                        })()}
                    </div>
                </div>
            );
        } else {
            return <div>{labelLivre}</div>;
        }
    };

    createLabelExtensia = () => {
        const { listeOfLivreExtensia } = this.props;
        const label = "OFS EXTENSIA";
        const mobile = this.isMobile();
        if (listeOfLivreExtensia.length > 0) {
            return (
                <div style={{ width: '100%', display: 'flex', flexDirection: mobile ? 'column' : 'row', justifyContent: 'space-between', alignItems: mobile ? 'flex-start' : 'center', gap: mobile ? 6 : 0 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: mobile ? '4px' : '10px', flex: 1, fontSize: mobile ? '0.8em' : 'inherit' }}>
                        <span style={{ fontSize: '1.2em', color: '#115293' }}>{listeOfLivreExtensia.length}</span> EXTENSIA : <span style={{ fontSize: '1.2em', color: '#115293' }}>{euroFormat(this.state.totalCALivreExtensia)}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                        <Button variant="contained" color="primary" size={mobile ? 'small' : 'medium'} onClick={() => this.printList(listeOfLivreExtensia)}>
                            Imprimer
                        </Button>
                    </div>
                </div>
            );
        } else {
            return <div>{label}</div>;
        }
    };

    handleOrderChange = (orderBy, orderDirection) => {
        const columnsEnCours = this.columnsEnCours();
        this.sortedColumn = null;
        if (orderBy >= 0 && orderBy < columnsEnCours.length) {
            this.sortedColumn = columnsEnCours[orderBy].field;
        }
        this.orderDirection = orderDirection;
        console.log(this.sortedColumn, this.orderDirection);

    };

    formatNumber = (value) => {
        // Défensive: coerce les valeurs non-numériques à 0 pour éviter les "NaN"
        const num = Number(value);
        const safe = Number.isFinite(num) ? num : 0;
        return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(safe);
    };

    getMargeAbsolueData = () => {
        const { analyseMargesData } = this.state;
        const { details } = analyseMargesData;

        if (!details || !details.length) return [];

        const tranches = [
            { label: '<100€', min: 0, max: 100, count: 0, marge: 0, ca: 0 },
            { label: '<200€', min: 100, max: 200, count: 0, marge: 0, ca: 0 },
            { label: '<300€', min: 200, max: 300, count: 0, marge: 0, ca: 0 },
            { label: '<400€', min: 300, max: 400, count: 0, marge: 0, ca: 0 },
            { label: '<500€', min: 400, max: 500, count: 0, marge: 0, ca: 0 },
            { label: '<1000€', min: 500, max: 1000, count: 0, marge: 0, ca: 0 },
            { label: '>1000€', min: 1000, max: Infinity, count: 0, marge: 0, ca: 0 }
        ];

        details.forEach(item => {
            const marge = parseFloat(item.marge_absolue || item.marge || 0);
            const ca = parseFloat(item.prix_fact || 0);

            // Exclure les marges négatives des calculs
            if (marge >= 0) {
                const tranche = tranches.find(t => marge >= t.min && marge < t.max);
                if (tranche) {
                    tranche.count++;
                    tranche.marge += marge;
                    tranche.ca += ca;
                }
            }
        });

        return tranches;
    };

    getMargeAbsolueDataLivres = () => {
        const { analyseMargesLivresData } = this.state;
        const { details } = analyseMargesLivresData;

        if (!details || !details.length) return [];

        const tranches = [
            { label: '<100€', min: 0, max: 100, count: 0, marge: 0, ca: 0 },
            { label: '<200€', min: 100, max: 200, count: 0, marge: 0, ca: 0 },
            { label: '<300€', min: 200, max: 300, count: 0, marge: 0, ca: 0 },
            { label: '<400€', min: 300, max: 400, count: 0, marge: 0, ca: 0 },
            { label: '<500€', min: 400, max: 500, count: 0, marge: 0, ca: 0 },
            { label: '<1000€', min: 500, max: 1000, count: 0, marge: 0, ca: 0 },
            { label: '>1000€', min: 1000, max: Infinity, count: 0, marge: 0, ca: 0 }
        ];

        details.forEach(item => {
            const marge = parseFloat(item.marge_absolue || item.marge || 0);
            const ca = parseFloat(item.prix_fact || 0);

            // Exclure les marges négatives des calculs
            if (marge >= 0) {
                const tranche = tranches.find(t => marge >= t.min && marge < t.max);
                if (tranche) {
                    tranche.count++;
                    tranche.marge += marge;
                    tranche.ca += ca;
                }
            }
        });

        return tranches;
    };

    renderAnalyseMarges = () => {
        const { analyseMargesData } = this.state;
        const { totaux, details } = analyseMargesData;

        if (!totaux || !totaux.length) {
            return (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Typography>Chargement des données d'analyse...</Typography>
                </div>
            );
        }

        // Extraire le premier élément du tableau
        const data = totaux[0];

        const margeData = this.getMargeAbsolueData();

        return (
            <div style={{ padding: '20px' }}>
                {/* KPIs */}
                <Grid container spacing={3} style={{ marginBottom: 24 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">CA</Typography>
                            <Typography variant="h4">{this.formatNumber(data.ca_total)} €</Typography>
                            <Typography variant="body2">{data.total_commandes} commandes</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Prix Revient</Typography>
                            <Typography variant="h4">{this.formatNumber(data.cout_total)} €</Typography>
                            <Typography variant="body2">{this.formatNumber(data.cout_total / data.total_commandes)} € moyen/commande</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Marge Total</Typography>
                            <Typography variant="h4">{this.formatNumber(data.marge_totale)} €</Typography>
                            <Typography variant="body2">{data.marge_globale_pct}% global</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Efficacité/Temps</Typography>
                            <Typography variant="h4">{this.formatNumber(data.rentabilite_par_unite_temps)} €/m</Typography>
                            <Typography variant="body2">{this.formatNumber(data.temps_total_mo / 60)} heures</Typography>
                        </Card>
                    </Grid>
                </Grid>

                {/* Analyse par tranches avec graphiques */}
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                    <Grid item xs={12} md={6}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
                                    Répartition Quantité par Marge
                                </Typography>
                                <div style={{ height: '300px', position: 'relative' }}>
                                    <Doughnut
                                        data={{
                                            labels: margeData.filter(t => t.count > 0).map(t => t.label),
                                            datasets: [{
                                                data: margeData.filter(t => t.count > 0).map(t => t.count),
                                                backgroundColor: [
                                                    'rgba(255, 99, 132, 0.7)',
                                                    'rgba(54, 162, 235, 0.7)',
                                                    'rgba(255, 206, 86, 0.7)',
                                                    'rgba(75, 192, 192, 0.7)',
                                                    'rgba(153, 102, 255, 0.7)',
                                                    'rgba(255, 159, 64, 0.7)',
                                                    'rgba(201, 203, 207, 0.7)'
                                                ],
                                                borderColor: [
                                                    'rgba(255, 99, 132, 1)',
                                                    'rgba(54, 162, 235, 1)',
                                                    'rgba(255, 206, 86, 1)',
                                                    'rgba(75, 192, 192, 1)',
                                                    'rgba(153, 102, 255, 1)',
                                                    'rgba(255, 159, 64, 1)',
                                                    'rgba(201, 203, 207, 1)'
                                                ],
                                                borderWidth: 2
                                            }]
                                        }}
                                        options={{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            plugins: {
                                                legend: {
                                                    position: 'bottom',
                                                    labels: {
                                                        padding: 20,
                                                        usePointStyle: true
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
                                    CA par Tranche de Marge
                                </Typography>
                                <div style={{ height: '300px', position: 'relative' }}>
                                    <Bar
                                        data={{
                                            labels: margeData.filter(t => t.count > 0).map(t => t.label),
                                            datasets: [{
                                                label: 'CA par Tranche (€)',
                                                data: margeData.filter(t => t.count > 0).map(t => t.ca),
                                                backgroundColor: 'rgba(54, 162, 235, 0.6)',
                                                borderColor: 'rgba(54, 162, 235, 1)',
                                                borderWidth: 1,
                                                hoverBackgroundColor: 'rgba(54, 162, 235, 0.8)',
                                                hoverBorderColor: 'rgba(54, 162, 235, 1)'
                                            }]
                                        }}
                                        options={{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            plugins: {
                                                legend: {
                                                    display: false
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    beginAtZero: true,
                                                    ticks: {
                                                        callback: function (value) {
                                                            return new Intl.NumberFormat('fr-FR').format(value) + ' €';
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Tableau récapitulatif */}
                <Card style={{ marginBottom: '20px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>Récapitulatif par Tranche</Typography>
                        <Grid container spacing={2}>
                            {margeData.filter(t => t.count > 0).map((tranche, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Paper style={{ padding: '12px', textAlign: 'center' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>{tranche.label}</Typography>
                                        <Typography variant="h6" color="primary">{tranche.count} OF</Typography>
                                        <Typography variant="body2">{this.formatNumber(tranche.ca)} € CA</Typography>
                                        <Typography variant="body2">{this.formatNumber(tranche.marge)} € marge</Typography>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>

                <MaterialTable
                    style={{ fontSize: 12 }}
                    columns={[
                        {
                            title: 'OF',
                            field: 'num_sachet',
                            type: 'numeric',
                            align: 'center',
                            cellStyle: { fontWeight: 'bold', textAlign: 'center' },
                            width: 80
                        },
                        {
                            title: 'Référence CV',
                            field: 'ref_cv',
                            render: rowData => rowData.ref_cv || rowData.ref,
                            width: 110
                        },
                        {
                            title: 'Référence',
                            field: 'ref',
                            width: 100
                        },
                        {
                            title: 'CA (€)',
                            field: 'prix_fact',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.prix_fact) + ' €',
                            width: 100
                        },
                        {
                            title: 'Coût (€)',
                            field: 'revient_piece',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.revient_piece) + ' €',
                            width: 100
                        },
                        {
                            title: 'Marge (€)',
                            field: 'marge',
                            type: 'numeric',
                            render: rowData => {
                                const marge = rowData.marge || 0;
                                let color = '#27ae60'; // vert par défaut
                                if (marge < 0) color = '#e74c3c'; // rouge
                                else if (marge < 50) color = '#e67e22'; // orange
                                else if (marge < 100) color = '#f39c12'; // jaune
                                else if (marge < 200) color = '#2ecc71'; // vert clair

                                return (
                                    <span style={{
                                        color,
                                        fontWeight: 'bold',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {this.formatNumber(marge)} €
                                    </span>
                                );
                            },
                            width: 100
                        },
                        {
                            title: 'Marge (%)',
                            field: 'pourcentage_marge',
                            type: 'numeric',
                            render: rowData => {
                                const pct = rowData.pourcentage_marge || 0;
                                let color = '#27ae60'; // vert par défaut
                                if (pct < 0) color = '#e74c3c'; // rouge
                                else if (pct < 5) color = '#e67e22'; // orange
                                else if (pct < 15) color = '#f39c12'; // jaune
                                else if (pct < 20) color = '#f1c40f'; // jaune clair
                                else if (pct < 50) color = '#2ecc71'; // vert clair

                                return (
                                    <span style={{
                                        color,
                                        fontWeight: 'bold',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {pct}%
                                    </span>
                                );
                            },
                            width: 100
                        },
                        {
                            title: 'Temps (min)',
                            field: 'plus_mo',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.plus_mo || 0) + ' min',
                            width: 90
                        },
                        {
                            title: 'Marge €/m',
                            field: 'marge_par_unite_temps',
                            type: 'numeric',
                            render: rowData => {
                                const margeTemps = rowData.marge_par_unite_temps || 0;
                                let color = '#95a5a6'; // gris par défaut
                                if (margeTemps < 0) color = '#e74c3c'; // rouge
                                else if (margeTemps < 2) color = '#e67e22'; // orange foncé
                                else if (margeTemps < 4) color = '#f39c12'; // orange
                                else if (margeTemps < 6) color = '#f1c40f'; // jaune
                                else if (margeTemps < 8) color = '#2ecc71'; // vert clair
                                else if (margeTemps < 12) color = '#27ae60'; // vert
                                else color = '#16a085'; // vert foncé

                                return (
                                    <span style={{
                                        color,
                                        fontWeight: 'bold',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        {this.formatNumber(margeTemps)}
                                    </span>
                                );
                            },
                            width: 90
                        },
                        {
                            title: 'Marge %',
                            field: 'classe_pourcentage',
                            align: 'center',
                            render: rowData => {
                                const classe = rowData.classe_pourcentage;
                                const getColorByPourcentage = (classe) => {
                                    if (classe?.includes('EXCELLENT')) return '#27ae60';
                                    if (classe?.includes('BON')) return '#2ecc71';
                                    if (classe?.includes('MOYEN')) return '#f39c12';
                                    if (classe?.includes('FAIBLE')) return '#e67e22';
                                    if (classe?.includes('DEFICIT')) return '#e74c3c';
                                    return '#95a5a6';
                                };
                                return (
                                    <span style={{
                                        background: getColorByPourcentage(classe),
                                        color: '#fff',
                                        padding: '2px 6px',
                                        borderRadius: '3px',
                                        fontSize: '0.7rem',
                                        fontWeight: 'bold'
                                    }}>
                                        {classe?.replace('_%', '').replace('_', ' ')}
                                    </span>
                                );
                            },
                            width: 100
                        },
                        {
                            title: 'Marge €',
                            field: 'classe_valeur',
                            align: 'center',
                            render: rowData => {
                                const classe = rowData.classe_valeur;
                                const getColorByValeur = (classe) => {
                                    if (classe?.includes('TRES_FORT')) return '#27ae60';
                                    if (classe?.includes('FORT')) return '#2ecc71';
                                    if (classe?.includes('MOYEN')) return '#f39c12';
                                    if (classe?.includes('FAIBLE')) return '#e67e22';
                                    if (classe?.includes('DEFICIT')) return '#e74c3c';
                                    return '#95a5a6';
                                };
                                return (
                                    <span style={{
                                        background: getColorByValeur(classe),
                                        color: '#fff',
                                        padding: '2px 6px',
                                        borderRadius: '3px',
                                        fontSize: '0.7rem',
                                        fontWeight: 'bold'
                                    }}>
                                        {classe?.replace('_€', '').replace('_', ' ')}
                                    </span>
                                );
                            },
                            width: 100
                        }
                    ]}
                    data={details}
                    title="Détail des Marges"
                    options={{
                        exportButton: true,
                        exportAllData: true,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        padding: 'dense',
                        sorting: true,
                        search: true,
                        filtering: false,
                        exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "analyse_marges_detail"),
                        headerStyle: {
                            backgroundColor: '#f5f5f5',
                            fontWeight: 'bold'
                        },
                        rowStyle: rowData => ({
                            backgroundColor: rowData.tableData.id % 2 === 1 ? '#fafafa' : 'white'
                        })
                    }}
                    localization={localization}
                />
            </div>
        );
    };

    renderAnalyseMargesLivres = () => {
        const { analyseMargesLivresData } = this.state;
        const { totaux, details } = analyseMargesLivresData;

        if (!totaux || !totaux.length) {
            return (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <Typography>Chargement des données d'analyse livrés...</Typography>
                </div>
            );
        }

        // Extraire le premier élément du tableau
        const data = totaux[0];

        const margeData = this.getMargeAbsolueDataLivres();

        return (
            <div style={{ padding: '20px' }}>
                {/* KPIs */}
                <Grid container spacing={3} style={{ marginBottom: 24 }}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">CA Facturé</Typography>
                            <Typography variant="h4">{this.formatNumber(data.ca_total)} €</Typography>
                            <Typography variant="body2">{data.total_commandes} commandes livrées</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Prix Revient</Typography>
                            <Typography variant="h4">{this.formatNumber(data.cout_total)} €</Typography>
                            <Typography variant="body2">{this.formatNumber(data.cout_total / data.total_commandes)} € moyen/commande</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Marge Réelle</Typography>
                            <Typography variant="h4">{this.formatNumber(data.marge_totale)} €</Typography>
                            <Typography variant="body2">{data.marge_globale_pct}% global</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card style={{ textAlign: 'center', padding: '16px' }}>
                            <Typography variant="h6" color="primary">Efficacité Réelle</Typography>
                            <Typography variant="h4">{this.formatNumber(data.rentabilite_par_unite_temps)} €/m</Typography>
                            <Typography variant="body2">{this.formatNumber(data.temps_total_mo / 60)} heures réelles</Typography>
                        </Card>
                    </Grid>
                </Grid>

                {/* Analyse par tranches avec graphiques */}
                <Grid container spacing={3} style={{ marginBottom: '20px' }}>
                    <Grid item xs={12} md={6}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
                                    Répartition Quantité par Marge (Livrés)
                                </Typography>
                                <div style={{ height: '300px', position: 'relative' }}>
                                    <Doughnut
                                        data={{
                                            labels: margeData.filter(t => t.count > 0).map(t => t.label),
                                            datasets: [{
                                                data: margeData.filter(t => t.count > 0).map(t => t.count),
                                                backgroundColor: [
                                                    'rgba(39, 174, 96, 0.7)',   // Vert pour livrés
                                                    'rgba(46, 204, 113, 0.7)',
                                                    'rgba(52, 152, 219, 0.7)',
                                                    'rgba(155, 89, 182, 0.7)',
                                                    'rgba(241, 196, 15, 0.7)',
                                                    'rgba(230, 126, 34, 0.7)',
                                                    'rgba(231, 76, 60, 0.7)'
                                                ],
                                                borderColor: [
                                                    'rgba(39, 174, 96, 1)',
                                                    'rgba(46, 204, 113, 1)',
                                                    'rgba(52, 152, 219, 1)',
                                                    'rgba(155, 89, 182, 1)',
                                                    'rgba(241, 196, 15, 1)',
                                                    'rgba(230, 126, 34, 1)',
                                                    'rgba(231, 76, 60, 1)'
                                                ],
                                                borderWidth: 2
                                            }]
                                        }}
                                        options={{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            plugins: {
                                                legend: {
                                                    position: 'bottom',
                                                    labels: {
                                                        padding: 20,
                                                        usePointStyle: true
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom style={{ textAlign: 'center' }}>
                                    CA Facturé par Tranche de Marge
                                </Typography>
                                <div style={{ height: '300px', position: 'relative' }}>
                                    <Bar
                                        data={{
                                            labels: margeData.filter(t => t.count > 0).map(t => t.label),
                                            datasets: [{
                                                label: 'CA Facturé par Tranche (€)',
                                                data: margeData.filter(t => t.count > 0).map(t => t.ca),
                                                backgroundColor: 'rgba(39, 174, 96, 0.6)',
                                                borderColor: 'rgba(39, 174, 96, 1)',
                                                borderWidth: 1,
                                                hoverBackgroundColor: 'rgba(39, 174, 96, 0.8)',
                                                hoverBorderColor: 'rgba(39, 174, 96, 1)'
                                            }]
                                        }}
                                        options={{
                                            responsive: true,
                                            maintainAspectRatio: false,
                                            plugins: {
                                                legend: {
                                                    display: false
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    beginAtZero: true,
                                                    ticks: {
                                                        callback: function (value) {
                                                            return new Intl.NumberFormat('fr-FR').format(value) + ' €';
                                                        }
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Tableau récapitulatif */}
                <Card style={{ marginBottom: '20px' }}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>Récapitulatif par Tranche (Livrés)</Typography>
                        <Grid container spacing={2}>
                            {margeData.filter(t => t.count > 0).map((tranche, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <Paper style={{ padding: '12px', textAlign: 'center' }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>{tranche.label}</Typography>
                                        <Typography variant="h6" color="primary">{tranche.count} OF</Typography>
                                        <Typography variant="body2">{this.formatNumber(tranche.ca)} € CA</Typography>
                                        <Typography variant="body2">{this.formatNumber(tranche.marge)} € marge</Typography>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>

                {/* Tableau des détails avec MaterialTable pour données livrées */}
                <MaterialTable
                    style={{ fontSize: 12 }}
                    columns={[
                        {
                            title: 'OF',
                            field: 'num_sachet',
                            type: 'numeric',
                            align: 'center',
                            cellStyle: { fontWeight: 'bold', textAlign: 'center' },
                            width: 80
                        },
                        {
                            title: 'Date Fact.',
                            field: 'date_fact',
                            type: 'date',
                            render: rowData => new Date(rowData.date_fact).toLocaleDateString('fr-FR'),
                            width: 100
                        },
                        {
                            title: 'Référence CV',
                            field: 'ref_cv',
                            render: rowData => rowData.ref_cv || rowData.ref,
                            width: 110
                        },
                        {
                            title: 'Référence',
                            field: 'ref',
                            width: 100
                        },
                        {
                            title: 'CA Facturé (€)',
                            field: 'prix_fact',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.prix_fact) + ' €',
                            width: 110
                        },
                        {
                            title: 'Coût (€)',
                            field: 'revient_piece',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.revient_piece) + ' €',
                            width: 100
                        },
                        {
                            title: 'Marge Réelle (€)',
                            field: 'marge',
                            type: 'numeric',
                            render: rowData => (
                                <span style={{ color: rowData.marge >= 0 ? 'green' : 'red' }}>
                                    {this.formatNumber(rowData.marge)} €
                                </span>
                            ),
                            width: 120
                        },
                        {
                            title: 'Marge (%)',
                            field: 'pourcentage_marge',
                            type: 'numeric',
                            render: rowData => (
                                <span style={{ color: rowData.pourcentage_marge >= 30 ? 'green' : 'red' }}>
                                    {rowData.pourcentage_marge}%
                                </span>
                            ),
                            width: 100
                        },
                        {
                            title: 'Temps Réel (min)',
                            field: 'temps_total_ouvrier',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.temps_total_ouvrier || 0) + ' min',
                            width: 110
                        },
                        {
                            title: 'Marge €/m',
                            field: 'marge_par_unite_temps',
                            type: 'numeric',
                            render: rowData => (
                                <span style={{
                                    color: rowData.marge_par_unite_temps >= 2 ? '#27ae60' :
                                        rowData.marge_par_unite_temps >= 1 ? '#f39c12' : '#e74c3c',
                                    fontWeight: 'bold'
                                }}>
                                    {this.formatNumber(rowData.marge_par_unite_temps || 0)}
                                </span>
                            ),
                            width: 110
                        },
                        {
                            title: 'Poids Réel (g)',
                            field: 'poids_u',
                            type: 'numeric',
                            render: rowData => this.formatNumber(rowData.poids_u || 0) + ' g',
                            width: 100
                        },
                        {
                            title: 'Marge %',
                            field: 'classe_pourcentage',
                            align: 'center',
                            render: rowData => {
                                const classe = rowData.classe_pourcentage;
                                const getColorByPourcentage = (classe) => {
                                    if (classe?.includes('EXCELLENT')) return '#27ae60';
                                    if (classe?.includes('BON')) return '#2ecc71';
                                    if (classe?.includes('MOYEN')) return '#f39c12';
                                    if (classe?.includes('FAIBLE')) return '#e67e22';
                                    if (classe?.includes('DEFICIT')) return '#e74c3c';
                                    return '#95a5a6';
                                };
                                return (
                                    <span style={{
                                        background: getColorByPourcentage(classe),
                                        color: '#fff',
                                        padding: '2px 6px',
                                        borderRadius: '3px',
                                        fontSize: '0.7rem',
                                        fontWeight: 'bold'
                                    }}>
                                        {classe?.replace('_%', '').replace('_', ' ')}
                                    </span>
                                );
                            },
                            width: 100
                        },
                        {
                            title: 'Marge €',
                            field: 'classe_valeur',
                            align: 'center',
                            render: rowData => {
                                const classe = rowData.classe_valeur;
                                const getColorByValeur = (classe) => {
                                    if (classe?.includes('TRES_FORT')) return '#27ae60';
                                    if (classe?.includes('FORT')) return '#2ecc71';
                                    if (classe?.includes('MOYEN')) return '#f39c12';
                                    if (classe?.includes('FAIBLE')) return '#e67e22';
                                    if (classe?.includes('DEFICIT')) return '#e74c3c';
                                    return '#95a5a6';
                                };
                                return (
                                    <span style={{
                                        background: getColorByValeur(classe),
                                        color: '#fff',
                                        padding: '2px 6px',
                                        borderRadius: '3px',
                                        fontSize: '0.7rem',
                                        fontWeight: 'bold'
                                    }}>
                                        {classe?.replace('_€', '').replace('_', ' ')}
                                    </span>
                                );
                            },
                            width: 100
                        }
                    ]}
                    data={details}
                    title="Détail des Marges Livrées (Données Réelles)"
                    options={{
                        exportButton: true,
                        exportAllData: true,
                        pageSize: 20,
                        pageSizeOptions: [10, 20, 50, 100],
                        padding: 'dense',
                        sorting: true,
                        search: true,
                        filtering: false,
                        exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "analyse_marges_livres_detail"),
                        headerStyle: {
                            backgroundColor: '#e8f5e8',
                            fontWeight: 'bold'
                        },
                        rowStyle: rowData => ({
                            backgroundColor: rowData.tableData.id % 2 === 1 ? '#f9fdf9' : 'white'
                        })
                    }}
                    localization={localization}
                />
            </div>
        );
    };

    render() {
        const mobile = this.isMobile();

        return (
            <div style={{ padding: mobile ? '0 4px' : undefined }}>
                {/* Mobile: top bar with Filtres + Afficher buttons */}
                {mobile && (
                    <div style={{ display: 'flex', gap: 8, marginBottom: 4, padding: '4px' }}>
                        <Button
                            variant="outlined"
                            startIcon={<FilterListIcon />}
                            onClick={() => this.setState({ filterOpen: true })}
                            size="small"
                            style={{ flex: 1 }}
                        >
                            Filtres
                        </Button>
                        <Button variant="contained" color="primary" size="small" style={{ flex: 1 }} onClick={this.refreshLists}>
                            Afficher
                        </Button>
                    </div>
                )}

                {/* Filter section - always mounted, overlay on mobile */}
                <div
                    style={mobile ? {
                        display: this.state.filterOpen ? 'flex' : 'none',
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        zIndex: 1200, backgroundColor: '#fff',
                        flexDirection: 'column', overflowY: 'auto', padding: 12,
                        WebkitOverflowScrolling: 'touch'
                    } : {}}
                    onClick={mobile ? e => e.stopPropagation() : undefined}
                    onTouchStart={mobile ? e => e.stopPropagation() : undefined}
                    onMouseDown={mobile ? e => e.stopPropagation() : undefined}
                >
                    {/* Mobile overlay header */}
                    {mobile && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, borderBottom: '1px solid #eee', paddingBottom: 8 }}>
                            <Typography variant="h6">Filtres</Typography>
                            <IconButton onClick={() => this.setState({ filterOpen: false })}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    )}

                    {/* Desktop: Afficher button above filters */}
                    {!mobile && (
                        <div className="col-auto" style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button variant="contained" color="primary" onClick={this.refreshLists}>Afficher</Button>
                        </div>
                    )}

                    {mobile ? (
                        /* ===== MOBILE: layout vertical compact ===== */
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {/* Client tree - full width */}
                            <div style={{ width: '100%' }}>
                                <TreeClient handleChange={this.handleChangeClient} />
                            </div>

                            {/* Dates en ligne */}
                            <div style={{ display: 'flex', gap: 6 }}>
                                <TextField margin='dense' fullWidth type='date' value={this.state.debut} onChange={e => e.target.value && this.onChange(e.target.value, 'debut')} label='Début' variant="outlined" size='small' InputLabelProps={{ shrink: true }} />
                                <TextField margin='dense' fullWidth type='date' value={this.state.fin} onChange={e => e.target.value && this.onChange(e.target.value, 'fin')} label='Fin' variant="outlined" size='small' InputLabelProps={{ shrink: true }} />
                            </div>

                            {/* Autocompletes en grille 2 col */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={this.dataImperatif}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(e, values) => this.setState({ imperatif: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Impératif" variant="outlined" size='small' />}
                                    />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={this.dataDevis}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(e, values) => this.setState({ devis: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Devis" variant="outlined" size='small' />}
                                    />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={this.dataTypeCommande}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(e, values) => this.setState({ tournee: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Tournée" variant="outlined" size='small' />}
                                    />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={this.dataFacon}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(e, values) => this.setState({ facon: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Façon" variant="outlined" size='small' />}
                                    />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={this.dataResa}
                                        getOptionLabel={(option) => option.description}
                                        onChange={(e, values) => this.setState({ typeResa: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Réserv." variant="outlined" size='small' />}
                                    />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <Autocomplete
                                        options={Object.values(this.props.listeTypeCom || {})}
                                        getOptionLabel={(option) => option.desc}
                                        onChange={(e, values) => this.setState({ commission: values })}
                                        autoHighlight autoComplete clearOnEscape
                                        renderInput={(params) => <TextField margin='dense' {...params} label="Commission" variant="outlined" size='small' />}
                                    />
                                </div>
                            </div>

                            {/* FilterSelect / FilterInput en grille 2 col */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterSelect label='Type Cmd' labelId='id' labelDescription="label" onChange={(e) => { this.onChange(e, 'typeCommande') }} options={this.props.listeTypeCommande} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterSelect label='Stade' labelId='id_stade' onChange={this.onChange} options={this.props.listeStade} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterSelect label='Metal' labelId='id_type' onChange={this.onChange} options={this.props.listeMetaux} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterSelect label='Type' labelId='id_typ_prod' onChange={this.onChange} options={this.props.listeTypeProduit} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterSelect label='Statut' labelId='Statut' onChange={this.onChange} options={this.props.listeStatut} labelDescription='OF_interne' />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterInput label='Ref_Clt' type='text' onChange={this.onChange} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterInput label='Ref' type='text' onChange={this.onChange} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterInput label='Of' onChange={this.onChange} />
                                </div>
                                <div style={{ flex: '1 1 48%' }}>
                                    <FilterInput label='Facture' onChange={this.onChange} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        /* ===== DESKTOP: layout horizontal classique ===== */
                        <div className='row'>
                            <div className='col-auto'>
                                <TreeClient handleChange={this.handleChangeClient} />
                            </div>
                            <div className='col-sm' style={{ padding: '4px' }}>
                                <TextField margin='dense' fullWidth type='date' value={this.state.debut} onChange={e => e.target.value && this.onChange(e.target.value, 'debut')} label='Debut' variant="outlined" size='small' />
                                <TextField margin='dense' fullWidth type='date' value={this.state.fin} onChange={e => e.target.value && this.onChange(e.target.value, 'fin')} label='Fin' variant="outlined" size='small' />
                                <Autocomplete
                                    options={this.dataImperatif}
                                    getOptionLabel={(option) => option.description}
                                    onChange={(e, values) => this.setState({ imperatif: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField margin='dense' {...params} label="Impératif" variant="outlined" size='small' />}
                                />
                                <Autocomplete
                                    options={this.dataDevis}
                                    getOptionLabel={(option) => option.description}
                                    onChange={(e, values) => this.setState({ devis: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField {...params} label="Devis" variant="outlined" margin='dense' size='small' />}
                                />
                            </div>
                            <div className='col-sm' style={{ padding: '4px' }}>
                                <Autocomplete
                                    options={this.dataTypeCommande}
                                    getOptionLabel={(option) => option.description}
                                    onChange={(e, values) => this.setState({ tournee: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField margin='dense' {...params} label="Tournée" variant="outlined" size='small' />}
                                />
                                <Autocomplete
                                    options={this.dataFacon}
                                    getOptionLabel={(option) => option.description}
                                    onChange={(e, values) => this.setState({ facon: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField margin='dense' {...params} label="Façon" variant="outlined" size='small' />}
                                />
                                <Autocomplete
                                    options={this.dataResa}
                                    getOptionLabel={(option) => option.description}
                                    onChange={(e, values) => this.setState({ typeResa: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField margin='dense' {...params} label="Reservation" variant="outlined" size='small' />}
                                />
                                <Autocomplete
                                    options={Object.values(this.props.listeTypeCom || {})}
                                    getOptionLabel={(option) => option.desc}
                                    onChange={(e, values) => this.setState({ commission: values })}
                                    autoHighlight autoComplete clearOnEscape
                                    renderInput={(params) => <TextField margin='dense' {...params} label="Commission" variant="outlined" size='small' />}
                                />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterSelect label='Type Commande' labelId='id' labelDescription="label" onChange={(e) => { this.onChange(e, 'typeCommande') }} options={this.props.listeTypeCommande} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterSelect label='Stade' labelId='id_stade' onChange={this.onChange} options={this.props.listeStade} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterSelect label='Metal' labelId='id_type' onChange={this.onChange} options={this.props.listeMetaux} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterSelect label='Type' labelId='id_typ_prod' onChange={this.onChange} options={this.props.listeTypeProduit} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterSelect label='Statut' labelId='Statut' onChange={this.onChange} options={this.props.listeStatut} labelDescription='OF_interne' />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterInput label='Ref_Clt' type='text' onChange={this.onChange} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterInput label='Ref' type='text' onChange={this.onChange} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterInput label='Of' onChange={this.onChange} />
                            </div>
                            <div className="col-sm" style={{ padding: '4px 2px 0px 2px' }}>
                                <FilterInput label='Facture' onChange={this.onChange} />
                            </div>
                        </div>
                    )}

                    {/* Mobile: Afficher button at bottom of overlay */}
                    {mobile && (
                        <div style={{ marginTop: 12, padding: '0 4px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => { this.refreshLists(); this.setState({ filterOpen: false }); }}
                            >
                                Afficher
                            </Button>
                        </div>
                    )}
                </div>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        {this.createLabelEnCours()}
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="container-fluid">
                            <MaterialTable
                                style={{ fontSize: mobile ? 11 : 14 }}
                                columns={this.columnsEnCours()}
                                options={{
                                    exportButton: true,
                                    exportAllData: true,
                                    actionsColumnIndex: -1,
                                    padding: 'dense',
                                    exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "of_en_cours"),
                                    rowStyle: rowData => ({
                                        color: (rowData.date_l_imp === '1') ? '#ff0000' :
                                            rowData.of_reservation !== '0' ? '#1976d2' : '',
                                        backgroundColor: rowData.statut === '575' ? '#b4f998' : '',
                                    }),
                                    sorting: true,
                                }}
                                onOrderChange={this.handleOrderChange}
                                actions={[
                                    ...(!mobile ? [
                                        {
                                            icon: 'query_stats',
                                            tooltip: 'Tracer Of',
                                            onClick: (e, rowData) => this.tracerOf(rowData.num_sachet)
                                        },
                                        {
                                            icon: 'edit',
                                            tooltip: 'Editer Of',
                                            onClick: (e, rowData) => this.editerOf(rowData.num_sachet)
                                        },
                                    ] : []),
                                    {
                                        icon: 'print',
                                        tooltip: 'Imprimer OF',
                                        onClick: (event, rowData) => window.open(`https://www.extensia-france.com/printers/ofPrinter.php?ofs=${rowData.num_sachet}`, "_blank")
                                    },
                                    {
                                        icon: 'refresh',
                                        tooltip: 'Rafraichir',
                                        isFreeAction: true,
                                        onClick: () => this.props.getOfEnCours(this.getFilter()).then(() => this.listeEnCours())
                                    }
                                ]}
                                data={this.state.dataClone}
                                title="Ofs en cours"
                                components={{
                                    Toolbar: props => (
                                        <MTableToolbar {...props} />
                                    ),
                                }}
                                onRowClick={(e, rowData) => this.handleChange('selectedEnCours', rowData.num_sachet)}
                                localization={localization}
                            />
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        {this.createLabelLivre()}
                        {this.state.dataLivreClone.length !== 0 && <Button variant="contained" color="primary" onClick={() => this.printList(this.state.dataLivreClone)}>Imprimer</Button>}
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="container-fluid">
                            <MaterialTable
                                style={{ fontSize: mobile ? 11 : 14 }}
                                columns={[
                                    { align: 'center', title: 'Image', export: false, field: 'image', width: 130, hidden: mobile, render: rowData => this.renderZoomableImage(rowData) },
                                    { align: 'left', title: 'Ref', field: 'ref', type: 'numeric', width: 70, hidden: mobile },
                                    { align: 'left', title: 'Type', field: 'type_produit', hidden: true },
                                    { align: 'left', title: 'OF', field: 'num_sachet', type: 'numeric', width: 70 },
                                    { align: 'left', title: 'Date Créa', field: 'date_crea', width: 130, hidden: mobile },
                                    { align: 'left', title: 'Client', field: 'Nom_agence', width: 200 },
                                    { align: 'left', title: 'Stade', field: 'lestade', width: 70, hidden: mobile },
                                    { align: 'left', title: 'Ref Clt', field: 'ref_clt', width: 130 },
                                    { align: 'left', title: 'Métal', field: 'lemetal', width: 60 },
                                    { align: 'left', title: 'Désignation', field: 'designation', width: 300 },
                                    { align: 'left', title: 'Poids', field: 'poids_u', width: 70, hidden: mobile },
                                    { align: 'left', title: 'Prix HT', field: 'totht', width: 130, hidden: mobile },
                                    { align: 'left', title: 'Date Facture', field: 'date_fact', width: 130, hidden: mobile },
                                    { align: 'left', title: 'Facture', field: 'id_fact', width: 130, hidden: mobile },
                                ]}
                                options={{
                                    exportButton: true,
                                    exportAllData: true,
                                    actionsColumnIndex: -1,
                                    padding: 'dense',
                                    exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "of_livre"),
                                    rowStyle: rowData => ({
                                        backgroundColor: (this.state.selectedLivre === rowData.num_sachet) ? '#AED1FF' : ''
                                    }),
                                    sorting: true,
                                    onOrderChange: this.handleOrderChange
                                }}
                                actions={[
                                    ...(!mobile ? [{
                                        icon: 'create',
                                        tooltip: 'Tracer Of',
                                        onClick: (e, rowData) => this.tracerOf(rowData.num_sachet)
                                    }] : []),
                                    {
                                        icon: 'picture_as_pdf',
                                        tooltip: 'Afficher Facture',
                                        onClick: (event, rowData) => window.open(`https://www.extensia-france.com/printers/factPrinter2024.php?listeFact=${rowData.id_fact}`, "_blank")
                                    },
                                    {
                                        icon: 'refresh',
                                        tooltip: 'Rafraichir',
                                        isFreeAction: true,
                                        onClick: () => this.props.getOfLivre(this.getFilter()).then(() => this.listeLivre())
                                    }
                                ]}
                                data={this.state.dataLivreClone}
                                title="Ofs Livrés"
                                components={{
                                    Toolbar: props => (
                                        <MTableToolbar {...props} />
                                    ),
                                }}
                                onRowClick={(event, rowData) => this.handleChange('selectedLivre', rowData.num_sachet)}
                                localization={localization}
                            />
                            <Dialog
                                open={this.state.open}
                                onClose={() => this.setState({ open: false })}
                                fullWidth={true}
                                maxWidth={'xl'}
                            >
                                <DialogTitle id="form-dialog-title">Tracer OF</DialogTitle>
                                <DialogTitle style={{ position: 'absolute', right: 40 }} onClick={() => this.setState({ open: false })}><button className="btn btn-link">Fermer</button></DialogTitle>
                                <DialogContent>
                                    <TracerOf of={this.state.ofToTrace} open={this.state.open} />
                                </DialogContent>
                            </Dialog>
                            <Dialog
                                open={this.state.openEditOf}
                                onClose={() => this.setState({ openEditOf: false })}
                                fullWidth={true}
                            >
                                <DialogTitle id="form-dialog-title">Editer OF</DialogTitle>
                                <DialogTitle style={{ position: 'absolute', right: 40 }} onClick={() => this.setState({ openEditOf: false })}><button className="btn btn-link">Fermer</button></DialogTitle>
                                <DialogContent>
                                    <OfEditComponent onAction={this.refreshLists} />
                                </DialogContent>
                            </Dialog>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        {this.createLabelExtensia()}
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="container-fluid">
                            <MaterialTable
                                style={{ fontSize: mobile ? 11 : 14 }}
                                columns={[
                                    { align: 'center', title: 'Image', export: false, field: 'image', hidden: mobile, render: rowData => this.renderZoomableImage(rowData) },
                                    { align: 'left', title: 'Ref', field: 'ref', type: 'numeric', hidden: mobile },
                                    { align: 'left', title: 'OF', field: 'num_sachet', type: 'numeric' },
                                    { align: 'left', title: 'Date Créa', field: 'date_crea', hidden: mobile },
                                    { align: 'left', title: 'Client', field: 'Nom_agence' },
                                    { align: 'left', title: 'Stade', field: 'lestade', hidden: mobile },
                                    { align: 'left', title: 'Ref Clt', field: 'ref_clt' },
                                    { align: 'left', title: 'Métal', field: 'lemetal' },
                                    { align: 'left', title: 'Référence', field: 'ref', hidden: mobile },
                                    { align: 'left', title: 'Désignation', field: 'designation', minWidth: 150 },
                                    { align: 'left', title: 'Poids', field: 'poids_u', hidden: mobile },
                                    { align: 'left', title: 'Prix HT', field: 'totht', hidden: mobile },
                                    { align: 'left', title: 'Date Facture', field: 'date_fact', hidden: mobile },
                                    { align: 'left', title: 'Facture', field: 'id_fact', hidden: mobile },
                                ]}
                                options={{
                                    exportButton: true,
                                    exportAllData: true,
                                    actionsColumnIndex: -1,
                                    padding: 'dense',
                                    exportCsv: (allColumns, allData) => exportCsv(allColumns, allData, "of_livre_extensia"),
                                    rowStyle: rowData => ({
                                        backgroundColor: (this.state.selectedLivreExtensia === rowData.num_sachet) ? '#AED1FF' : ''
                                    }),
                                    sorting: true,
                                    onOrderChange: this.handleOrderChange
                                }}
                                actions={[
                                    ...(!mobile ? [{
                                        icon: 'create',
                                        tooltip: 'Tracer Of',
                                        onClick: (e, rowData) => this.tracerOf(rowData.num_sachet)
                                    }] : []),
                                    {
                                        icon: 'picture_as_pdf',
                                        tooltip: 'Afficher Facture',
                                        onClick: (event, rowData) => window.open(`https://www.extensia-france.com/printers/factExtensiaPrinter.php?listeFact=${rowData.id_fact}`, "_blank")
                                    },
                                    {
                                        icon: 'refresh',
                                        tooltip: 'Rafraichir',
                                        isFreeAction: true,
                                        onClick: () => this.props.getOfLivreExtensia(this.getFilter()).then(() => this.listeLivreExtensia())
                                    }
                                ]}
                                data={this.state.dataLivreCloneExtensia}
                                title="Ofs Livrés EXTENSIA"
                                components={{
                                    Toolbar: props => (
                                        <MTableToolbar {...props} />
                                    ),
                                }}
                                onRowClick={(event, rowData) => this.handleChange('selectedLivreExtensia', rowData.num_sachet)}
                                localization={localization}
                            />
                            <Dialog
                                open={this.state.open}
                                onClose={() => this.setState({ open: false })}
                                fullWidth={true}
                                fullScreen={mobile}
                                maxWidth={'xl'}
                            >
                                <DialogTitle id="form-dialog-title">Tracer OF</DialogTitle>
                                <DialogTitle style={{ position: 'absolute', right: 40 }} onClick={() => this.setState({ open: false })}><button className="btn btn-link">Fermer</button></DialogTitle>
                                <DialogContent>
                                    <TracerOf of={this.state.ofToTrace} open={this.state.open} />
                                </DialogContent>
                            </Dialog>
                            <Dialog
                                open={this.state.openEditOf}
                                onClose={() => this.setState({ openEditOf: false })}
                                fullWidth={true}
                                fullScreen={mobile}
                            >
                                <DialogTitle id="form-dialog-title">Editer OF</DialogTitle>
                                <DialogTitle style={{ position: 'absolute', right: 40 }} onClick={() => this.setState({ openEditOf: false })}><button className="btn btn-link">Fermer</button></DialogTitle>
                                <DialogContent>
                                    <OfEditComponent onAction={this.refreshLists} />
                                </DialogContent>
                            </Dialog>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Dialog
                    open={this.state.imageZoomOpen}
                    onClose={this.closeImageZoom}
                    fullWidth={true}
                    fullScreen={mobile}
                    maxWidth='lg'
                    PaperProps={{
                        style: {
                            backgroundColor: '#fff',
                            boxShadow: 'none'
                        }
                    }}
                >
                    <DialogContent
                        onClick={this.closeImageZoom}
                        style={{
                            padding: 0,
                            backgroundColor: '#fff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: mobile ? '100vh' : '85vh',
                            cursor: 'zoom-out'
                        }}
                    >
                        {this.state.zoomImageSrc && (
                            <img
                                src={this.state.zoomImageSrc}
                                alt={this.state.zoomImageTitle || 'Aperçu image'}
                                style={{
                                    maxWidth: '95%',
                                    maxHeight: mobile ? '95vh' : '90vh',
                                    objectFit: 'contain'
                                }}
                            />
                        )}
                    </DialogContent>
                </Dialog>

                {/* Popup Analyse des Marges */}
                <Dialog
                    open={this.state.openAnalyseMarges}
                    onClose={() => this.setState({ openAnalyseMarges: false })}
                    fullWidth={true}
                    fullScreen={mobile}
                    maxWidth='xl'
                >
                    <div style={{
                        padding: '20px 24px 16px',
                        borderBottom: '1px solid #e0e0e0',
                        position: 'relative',
                        backgroundColor: '#fafafa'
                    }}>
                        <Typography
                            variant="h4"
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: '#333',
                                margin: 0
                            }}
                        >
                            Analyse des Marges
                        </Typography>
                        <Button
                            onClick={() => this.setState({ openAnalyseMarges: false })}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                minWidth: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#f5f5f5',
                                color: '#666',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#e0e0e0';
                                e.target.style.color = '#333';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#f5f5f5';
                                e.target.style.color = '#666';
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <DialogContent style={{ padding: 0 }}>
                        {this.renderAnalyseMarges()}
                    </DialogContent>
                </Dialog>

                {/* Popup Analyse des Marges Livrés */}
                <Dialog
                    open={this.state.openAnalyseMargesLivres}
                    onClose={() => this.setState({ openAnalyseMargesLivres: false })}
                    fullWidth={true}
                    fullScreen={mobile}
                    maxWidth='xl'
                >
                    <div style={{
                        padding: '20px 24px 16px',
                        borderBottom: '1px solid #e0e0e0',
                        position: 'relative',
                        background: 'linear-gradient(135deg, #e8f5e8 0%, #d4f1d4 100%)'
                    }}>
                        <Typography
                            variant="h4"
                            style={{
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: '#2d5016',
                                margin: 0
                            }}
                        >
                            Analyse des Marges Livrés (Données Réelles)
                        </Typography>
                        <Button
                            onClick={() => this.setState({ openAnalyseMargesLivres: false })}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                minWidth: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#f0f8f0',
                                color: '#4a7c59',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#e0e8e0';
                                e.target.style.color = '#2d5016';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#f0f8f0';
                                e.target.style.color = '#4a7c59';
                            }}
                        >
                            <CloseIcon />
                        </Button>
                    </div>
                    <DialogContent style={{ padding: 0 }}>
                        {this.renderAnalyseMargesLivres()}
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    listeStade: state.generalData.listeStade,
    listeTypeProduit: state.generalData.listeTypeProduit,
    listeMetaux: state.generalData.listeMetaux,
    listeStatut: state.generalData.listeStatut,
    listeTypeCommande: state.generalData.typeCommande,
    listeTypeCom: state.generalData.listeTypeCom,
    listeOfEnCours: state.analyse.listeOfEnCours,
    listeOfLivre: state.analyse.listeOfLivre,
    listeOfLivreExtensia: state.analyse.listeOfLivreExtensia,
    listeOfs: state.ofs.listeOf,
});

const mapDispatchToProps = {
    getStade,
    getMetaux,
    getTypeProduit,
    getStatut,
    getOfEnCours,
    getOfLivre,
    getOfLivreExtensia,
    getOfFromId,
    setOfToEdit,
    getListeOf,
    getTypeCommande,
    getTypeCom,
    getAnalyseMargeTotaux,
    getAnalyseMargeClasses,
    getAnalyseMargeDetails,
    getAnalyseMargeEfficacite,
    getAnalyseMargeTotauxLivres,
    getAnalyseMargeClassesLivres,
    getAnalyseMargeDetailsLivres,
    getAnalyseMargeEfficaciteLivres
};

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(FilterTester));
